import React from 'react';
import SparkResourceSharePopover from 'components/common/Share/SparkResourceSharePopover';
import { SparkButton } from 'sharedComponents/UI';
import { ShareIcon08 } from 'components/SVG';
import { useResourceTypes } from 'hooks/EntityTypes/useResourceTypes';
import { usePopover } from 'hooks/common';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

type BoardShareButtonProps = {
  boardID: string;
};

function BoardShareButton({ boardID }: BoardShareButtonProps) {
  const { anchorEl, open, openPopover, closePopover } = usePopover();
  const { idByKeyMap } = useResourceTypes();
  return (
    <>
      <SparkButton
        sx={{
          textTransform: 'none',
          bgcolor: 'white',
          borderRadius: '10px',
          color: 'black',
          height: '43px',
          border: (theme) => `1px solid ${theme.palette.borderColor}`,
          paddingLeft: '20px',
          paddingRight: '20px',
        }}
        startIcon={<ShareIcon08 color='black' width={20} height={20} />}
        onClick={openPopover}
      >
        Share
      </SparkButton>

      <SparkResourceSharePopover
        open={open}
        onClose={closePopover}
        anchorEl={anchorEl}
        resourceID={boardID}
        resourceTypeID={idByKeyMap?.[SPARK_RESOURCE_TYPES.BOARDS] || ''}
      />
    </>
  );
}

export default BoardShareButton;
